<template>
  <div>
  <v-row>
  <v-col cols="12" xs="8" md="6" lg="6" xl="6" v-for="(item, i) in contents" :key="i">
    <!-- 内部リンク (Vue Router を使用) -->
    <router-link v-if="!item.external_link" :to="item.href">
      <v-hover v-slot="{ hover }" close-delay="200">
        <v-card height="100%" :elevation="hover ? 12 : 3" :class="{ 'on-hover': hover }">
          <v-banner>
            <div id="serviceTitle">
              <v-icon class="mb-1" color="indigo darken-4">
                {{ item.icon }}
              </v-icon>
              {{ item.title }}
            </div>
            <template v-slot:actions>
              <v-btn outlined color="red">
                {{ button }}
                <v-icon>mdi-magnify-plus-outline</v-icon>
              </v-btn>
            </template>
          </v-banner>
          <v-card-text id="description">
            {{ item.description }}
          </v-card-text>
        </v-card>
      </v-hover>
    </router-link>

    <!-- 外部リンク (通常の <a> タグを使用) -->
    <a v-else :href="item.href" target="_blank" rel="noopener noreferrer">
      <v-hover v-slot="{ hover }" close-delay="200">
        <v-card height="100%" :elevation="hover ? 12 : 3" :class="{ 'on-hover': hover }">
          <v-banner>
            <div id="serviceTitle">
              <v-icon class="mb-1" color="indigo darken-4">
                {{ item.icon }}
              </v-icon>
              {{ item.title }}
            </div>
            <template v-slot:actions>
              <v-btn outlined color="red">
                {{ button }}
                <v-icon>mdi-magnify-plus-outline</v-icon>
              </v-btn>
            </template>
          </v-banner>
          <v-card-text id="description">
            {{ item.description }}
          </v-card-text>
        </v-card>
      </v-hover>
    </a>

  </v-col>
</v-row>

  </div>
</template>

<style>
#description {
  white-space: pre-wrap;
  word-wrap: break-word;
  text-indent: 1em;
  line-height: 30px;
  color: #444444;
  font-size: 15px;
}
#serviceTitle {
  font-size: 20px;
}
</style>

<script>
export default {
  data () {
    return {
      button: '詳しく',
      contents: [
        {
          icon: 'mdi-security',
          title: 'ホームページ運用保守',
          description: 'WordPress,JoomlaをはじめとするCMSを利用したホームページのセキュリティ管理は、コニーシステムにお任せください。',
          href: '/hp_maintenance/',
          external_link: true
        },
        {
          icon: 'mdi-server-security',
          title: 'システム運用保守',
          description: 'システムの運用保守は、ご相談ください。',
          href: '/Service/Maintenance',
          external_link: false
        },
        {
          icon: 'mdi-school',
          title: '学会サポート',
          description: '国際学会、国内学会、研究会で講演し、また、多くの医療関係の学会のホームページ、演題登録システムを作成・運用してきた経験を活かし、低コストで学術大会をシステム面からサポートいたします。',
          href: '/Service/supportConference',
          external_link: false
        },
        {
          icon: 'mdi-file-document-outline',
          title: '学術研究機関向けサイト作成',
          description: '学術研究機関向けのホームページを作成いたします。更新が多い場合・会員サイト等が必要な場合等、お客様のご都合とご予算に合わせて提案いたします。',
          href: '/Service/academicSite',
          external_link: false
        },
        {
          icon: 'mdi-hand-heart',
          title: 'OSS製品のサポート',
          description: '各種OSS製品の導入支援、運用保守(セキュリティアップデート)、カスタマイズ、プラグインを開発いたします。',
          href: '/Service/supportOSS',
          external_link: false
        },
        {
          icon: 'mdi-charity',
          title: '受託開発',
          description: 'Java、C#、C++、php、ruby等によるシステムの受託開発いたします。また、弊社のe-Learninシステム、検索システム、会議システム、オンライン査読システム、診療予約システム、歯科予約システムを利用した受託開発も行います。',
          href: '/Service/Commissioned',
          external_link: false
        },
        {
          icon: 'mdi-lightbulb',
          title: '研究開発',
          description: '研究開発では、静止衛星を用いた高遅延環境での動画配信の効率的なプロトコルの調査、e-Learningシステムのヒューリスティック評価、アクセスログを用いたユーザビリティの改善などを行い、研究開発から得られた成果をソフトウェア開発にフィードバックしています。',
          href: '/Service/Investigation',
          external_link: false
        }
      ]
    }
  }
}
</script>
